<div>
  <div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="header-side"></div>
    <div class="dialog-title-text" cdkDragHandle>
      Save Sampling Frequency {{ ipdata.editData === null ? '' : '(id:' + ipdata.editData.id + ')' }}
    </div>
    <button mat-icon-button class="close-btn" (click)="closeModal()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="sfForm" (ngSubmit)="onSave()" *ngIf="isFormReady()" class="form-grid">
    <mat-dialog-content>
      <div class="form-grid-row">
        <!-- Sampling Type -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Sampling Type</mat-label>
          <mat-select formControlName="type" (selectionChange)="onSamplingTypeChange($event.value)"
            placeholder="- Select Sampling Type -">
            <mat-option *ngFor="let type of samplingTypes()" [value]="type.id">
              {{ type.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="sfForm.get('type')?.hasError('required') && sfForm.get('type')?.touched">
            Sampling Type is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-grid-row">

        <!-- Frequency Type -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Frequency Type</mat-label>
          <mat-select formControlName="freqType" placeholder="- Select Freq Type -">
            <mat-option *ngFor="let freqType of filteredFreqTypes()" [value]="freqType.id">
              {{ freqType.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="sfForm.get('freqType')?.hasError('required') && sfForm.get('freqType')?.touched">
            Frequency Type is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-grid-row">

        <!-- Frequency -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Frequency</mat-label>
          <input matInput type="text" (input)="roundOff($event, 9999, 0, 1, 'freq')" formControlName="freq"
            placeholder="Enter Frequency" min="1" />
          <mat-error *ngIf="sfForm.get('freq')?.hasError('required') && sfForm.get('freq')?.touched">
            Frequency is required
          </mat-error>
          <mat-error *ngIf="sfForm.get('freq')?.hasError('min')">
            Frequency must be at least 1
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-grid-row">

        <!-- Alert Threshold -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>{{ thresholdLabel() }}</mat-label>
          <input matInput type="text" (input)="roundOff($event, 9999, 0, 1, 'alertThreshold')"
            formControlName="alertThreshold" placeholder="Alert Threshold" min="1" />
          <mat-error
            *ngIf="sfForm.get('alertThreshold')?.hasError('required') && sfForm.get('alertThreshold')?.touched">
            Alert Threshold is required
          </mat-error>
          <mat-error *ngIf="sfForm.get('alertThreshold')?.hasError('min')">
            Alert Threshold must be at least 1
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-grid-row">
        <!-- Testing Type -->
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Testing Type</mat-label>
          <mat-select formControlName="testingType" placeholder="- Select Testing Type -">
            <mat-option *ngFor="let testingType of testingTypes()" [value]="testingType.id">
              {{ testingType.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="sfForm.get('testingType')?.hasError('required') && sfForm.get('testingType')?.touched">
            Testing Type is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-grid-row">        
        <mat-slide-toggle formControlName="sampleUpOnFirstDelivery" color="primary" >
          <span class="font-medium text-gray-700 w-44 inline-block">Take Sample upon first delivery?</span>
        </mat-slide-toggle>
      </div>
    </mat-dialog-content>
    <!-- Modal Footer -->
    <mat-dialog-actions align="end" class="dialog-footer">
      <button (click)="closeModal()" type="button" mat-raised-button color="primary">Cancel</button>
      @if(canSave){
        <button type="submit" mat-raised-button color="primary">Save</button>
      }
    </mat-dialog-actions>
  </form>
</div>